// create new array for countries and appending a new object that represents default value
/* eslint-disable */
const countries = [
    {
        name: 'Select a Country',
        id: '',
        regionCode: '',
        code: ''
    },
    ...window.beaches_app.page.countries
];

const callingCodesObj = require('~/js/modules/countryCallingCodes');

// create new array for states and appending a new object that represents default value
const states = [...window.beaches_app.page.states];


import '~/js/sections/weddings/includes/scroll-below';
import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import FileImageUpload from '~/js/components/form-controls/FileImageUpload';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';

ReactDOM.render(
  <CustomDatePicker
    name="checkInDate"
    inputClassName="checkin-date-input"
    wrapperClassName="col-xs-12 col-lg-12"
    isRequired
    displayPlaceHolder
    displayStringDate={false}
  />,
  document.getElementById('arrival-date-picker-validate'),
);

ReactDOM.render(
<CountryStateSelector
    countries={countries}
        states={states}
        countryName="countryCode"
        stateName="state"
        stateLabelWrapper="lg-12"
        stateInputWrapper="lg-12"
        countryLabelWrapper="lg-12"
        countryInputWrapper="lg-12"
    />,
    document.getElementById('country-state-selector')
);

ReactDOM.render(
    <CountryStateSelector
        countries={countries}
            states={states}
            countryName="guestCountryCode"
            stateName="guestState"
            stateLabelWrapper="lg-12"
            stateInputWrapper="lg-12"
            countryLabelWrapper="lg-12"
            countryInputWrapper="lg-12"
        />,
        document.getElementById('country-state-selector2')
    );

ReactDOM.render(
    <FileImageUpload
      fileSizeLimit={ 3 }
      isRequired
      name="document"
      btnMessage="CHOOSE FILE"
      displaySelectedFileName
    />,
    document.getElementById('upload-file')
  );

ReactDOM.render(
  <CustomRecaptcha
    wrapperClassName="xs-12 lg-12"
  />,
  document.getElementById('google-recaptcha')
);

// Form validations
import '~/js/modules/fend';

const $freeaanniversaryForm = $('.free-anniversary-form');

$freeaanniversaryForm.fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    bookingNumber: 'alphanumeric',
    // sandalsSelectNumber: 'number',
    // arrivalDate: 'date',
  },
  isMultiPart: true
});

// const $bookingNumber = $('#bookingNumberValidate');
// const $guest1mobileNumber = $('#guest1mobileNumber');
// const $arrivalDate = $('#arrival-date-picker-validate');
// const $resort = $('#resortCodeValidate');
// const $lastName = $('#lastNameValidate');
// const $errorMsg = $('#general-error');
const $email = $('#email');
// const $city = $('#city');
// const $termsLabel = $('.js-terms-label');
const $termConfirmation = $('#subscribeChk');
// const $resortSelected = $('select[name="resortSelected"]');
// const $guest1Title = $('select[name="guest1Title"]');
// const $guest2Title = $('select[name="guest2Title"]');
// const $guest1ContactPreference = $('select[name="guest1ContactPreference"]');

  // form elements references
  const $landlineNumber = $('#landLineNumber');
  const $mobileNumber = $('#mobileNumber');
  const $guestLandLineNumber = $('#guestLandLineNumber');
  const $guestMobileNumber = $('#guestMobileNumber');
  const $resortSelect = $('select[name="resort"]');
  const $checkInDate = $('input[name="checkInDate"]');
  const $submitButton = $('#submit-button');
  const $freeAnniversaryForm = $('#free-anniversary-form');


   // Form Validation
   $freeAnniversaryForm.fend({
    rules: {
      firstName: 'lettersOnly',
      lastName: 'lettersOnly',
      bookingNumber: 'alphanumeric',
      city: 'lettersOnly',
      state: 'lettersOnly',
      guestFirstName: 'lettersOnly',
      guestLastName: 'lettersOnly',
    },
    isMultiPart: true
  });


  // Phone number validations
  $landlineNumber.on('input', function validateNumber() {
    if (this.value) {
      $mobileNumber.removeAttr('required');
      $mobileNumber.trigger( 'blur' );
    }else {
      $mobileNumber.attr('required', true);
    }
  });
  
  $mobileNumber.on('input', function validateNumber() {
    if (this.value) {
      $landlineNumber.removeAttr('required');
      $landlineNumber.trigger( 'blur' );
    }else {
      $landlineNumber.attr('required', true);
    }
  });
  
  $guestLandLineNumber.on('input', function validateNumber() {
    if (this.value) {
      $guestMobileNumber.removeAttr('required');
      $guestMobileNumber.trigger( 'blur' );
    }else {
      $guestMobileNumber.attr('required', true);
    }
  });
  
  $guestMobileNumber.on('input', function validateNumber() {
    if (this.value) {
      $guestLandLineNumber.removeAttr('required');
      $guestLandLineNumber.trigger( 'blur' );
    }else {
      $guestLandLineNumber.attr('required', true);
    }
  });
  
  $submitButton.click( () => {
    const $actualResort = $resortSelect.val();
    const $actualDate = $checkInDate.val();
  
    $freeAnniversaryForm.attr('data-location', '/anniversaries/free/thankyou/?resortName=' + $actualResort + '&checkInDate=' + $actualDate);
  });
  
  $(document).ready(() => {
    const phoneTogglerOpts = {
      countryInput: '[name=countryCode]',
      countryCodeLabel: 'span.countryCode',
      phoneCodes: countryPhoneCodes
    };
  
    const countryCodeHandler = new PhoneCodeToggler(phoneTogglerOpts);
  
    countryCodeHandler.init();
  
    const phoneTogglerOptsTA = {
      countryInput: '[name=agencyCountry]',
      countryCodeLabel: 'span.countryCodeTA',
      phoneCodes: countryPhoneCodes
    };
  
    const taCountryCodeHandler = new PhoneCodeToggler(phoneTogglerOptsTA);
  
    taCountryCodeHandler.init();
  });

// let errors = [];
// let termsErrors;

// const validateBookingBtn = document.getElementById('validate-booking');
// const $arrivalDateHidden = $('input[name="arrivalDate"]');

// validateBookingBtn.addEventListener('click', e => {
//   // $('#arrivaldate').val($arrivalDateHidden);
//   errors = [];

//   if ($bookingNumber.val() === '') {
//     //$bookingNumber.addClass('has-error');
//     errors.push('booking Number');
//   } else {
//     $bookingNumber.removeClass('has-error');
//   }
//   if ($guest1mobileNumber.val() === '') {
//     //$bookingNumber.addClass('has-error');
//     errors.push('booking Number');
//   } else {
//     $guest1mobileNumber.removeClass('has-error');
//   }
//   if ($resortSelected.val() === '') {
//     //$bookingNumber.addClass('has-error');
//     errors.push('resort Selected');
//   } else {
//     $resortSelected.removeClass('has-error');
//   }
//   if ($guest1Title.val() === '') {
//     //$bookingNumber.addClass('has-error');
//     errors.push('guest1 Title');
//   } else {
//     $guest1Title.removeClass('has-error');
//   }
//   if ($guest2Title.val() === '') {
//     //$bookingNumber.addClass('has-error');
//     errors.push('guest2 Title');
//   } else {
//     $guest2Title.removeClass('has-error');
//   }
//   if ($guest1ContactPreference.val() === '') {
//     //$bookingNumber.addClass('has-error');
//     errors.push('guest1 ContactPreference');
//   } else {
//     $guest1ContactPreference.removeClass('has-error');
//   }
//   if ($arrivalDateHidden.val() === '') {
//     //$arrivalDate.find('.datepicker-text').addClass('has-error');
//     errors.push('arrival Date');
//   } else {
//     $arrivalDate.find('.datepicker-text').removeClass('has-error');
//   }
//   if ($resort.val() === '') {
//     //$resort.addClass('has-error');
//     errors.push('resort');
//   } else {
//     $resort.removeClass('has-error');
//   }
  if ($email.val() === '') {
    //$email.addClass('has-error');
    errors.push('email');
  } else {
    $email.removeClass('has-error');
  }
//   if ($city.val() === '') {
//     //$party.addClass('has-error');
//     errors.push('city');
//   } else {
//     $city.removeClass('has-error');
//   }
//   if ($lastName.val() === '') {
//     //$lastName.addClass('has-error');
//     errors.push('last name');
//   } else {
//     $lastName.removeClass('has-error');
//   }

//   if (errors.length > 0) {
//     $errorMsg.html('Please fill all the fields above');

//     return false;
//   } else {
//     $errorMsg.html('');
//   }

//   if ($termConfirmation.is(':checked') !== true) {
//     termsErrors++;
//     termsErrors === 1
//         ? $termsLabel.prepend(
//               '<label id="termConfirmation-error" class="has-error empty-field-error arial font-bold">Please Check the terms and conditions.</label>'
//           )
//         : '';

//     return false;
// }
// });

const $label = $('#label_conditions');

$termConfirmation.change(() => {
    if ($termConfirmation.is(':checked') === true) {
      termsErrors = 0;
      // $submitButton.prop('disabled', false);
      $('#termConfirmation-error').remove();
      $label.addClass('active');
    } else {
      $label.removeClass('active');
    }
});

// // form elements references
// const $countrySelector = $('select[name="country"]');
// const $countrySelector2 = $('select[name="country2"]');
// const $subscribeLabel = $('.form-label[for="subscribe"]');

// $subscribeLabel.text($subscribeLabel.data('normal'));

// $countrySelector.on('change', event => {
//     const countryId = event.target.value;

//     $subscribeLabel.text($subscribeLabel.data('normal'));

//     if (countryId === 'CA') {
//         $subscribeLabel.html($subscribeLabel.data('canada'));
//     }
// });

// $countrySelector2.on('change', event => {
//     const countryId = event.target.value;

//     $subscribeLabel.text($subscribeLabel.data('normal'));

//     if (countryId === 'CA') {
//         $subscribeLabel.html($subscribeLabel.data('canada'));
//     }
// });

// $(document).ready(() => {
//     $('[name=country]').on('change', function() {
//         const selectedCountry = $(this).val();

//         callingCodesObj.countryCodes.map(function(index) {
//             if (selectedCountry === index.code) {
//                 $('span.countryCode').html(index.dial_code);
//             }
//         });
//     });
//     $('[name=country2]').on('change', function() {
//         const selectedCountry = $(this).val();

//         callingCodesObj.countryCodes.map(function(index) {
//             if (selectedCountry === index.code) {
//                 $('span.countryCode').html(index.dial_code);
//             }
//         });
//     });
// });

